import { legacy_createStore, applyMiddleware, compose } from "redux"
import createSagaMiddleware from "redux-saga"
import rootReducer from "./reducers"

const sagaMiddleware = createSagaMiddleware()
const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose

// v2 동일: localStorage 'info' 키에 전체 redux 상태 영속화
const loadState = () => {
  try {
    const serialized = localStorage.getItem('info')
    return serialized ? JSON.parse(serialized) : undefined
  } catch (_) {
    return undefined
  }
}

const saveState = (state) => {
  try {
    localStorage.setItem('info', JSON.stringify(state))
  } catch (err) {
    console.error('Error saving info to local storage:', err)
  }
}

const store = legacy_createStore(
  rootReducer,
  loadState(),
  composeEnhancers(applyMiddleware(sagaMiddleware))
)

store.subscribe(() => { saveState(store.getState()) })

export default store
